// Which days and slots Book & pay offers for the car's district (Form v3,
// 20 Oct 2026): GET /api/v2/availability (app/services/availability.rb). The
// answer's `days` are { 'yyyy-MM-dd': { state, reason, slots: { <slot>:
// { state, reason } } } }, state 'available' | 'limited' | 'unavailable'.
// Today the server knows only the form's own rules; stage 0 of the operator
// availability plugs in there, and the day chips and time slots grey an
// unavailable day or slot and show the short reason a limited one carries.
// Pure, so node --test pins it (availability.test.mjs).

// The browser's calendar day, as the server keys it.
export const dayKey = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

// A day's or a slot's { state, reason }, or null when nothing is known (no
// district yet, or no answer): then it is available, as before.
export const dayState = (days, date) => (days && date instanceof Date && !isNaN(date) && days[dayKey(date)]) || null
export const slotState = (days, date, slot) => dayState(days, date)?.slots?.[slot] || null

// The note a chip or a slot shows: the reason, unless it is available.
export const stateNote = s => (s && s.state !== 'available' && s.reason) || null
export const isOff = s => s?.state === 'unavailable'
